import { PaymentStatus } from "@prisma/postgresClient";

export default PaymentStatus;
